import {
  CardContent,
  Card,
  Grid,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { getPublicImagePath } from "../App";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    primary: {
      marginTop: theme.spacing(2),
      alignItems: 'center',
      justifyContent: 'center',
      top: `50%`,
      left: `50%`,
    },
  })
);

export default function LandingPage() {
  const classes = useStyles();
  return (
    <ResponsiveDrawer title="Page Not Found">
      <Grid container spacing={1} className={classes.primary}>
        <Grid item>
          <Card className={classes.primary}>
            <CardContent>
              <Alert severity="error">
                <AlertTitle> Page Not Found</AlertTitle>   
                  This is not the page you are looking for. The page you were looking for could not be found.
              </Alert>
              <br/>
              <img className={classes.image} src={getPublicImagePath(`/VendBroken.png`)} alt={"Page Not Found"}></img>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </ResponsiveDrawer>
  );

}
